/*
 * Veil Points side panel (replaces Growave's Rewards pop-up). Opened by [data-rv-points] links: the header
 * "Veil Points" link and the phone menu. Same data as My Account > Veil Points and the cart box
 * (Worker GET /apps/rv/points), so everything shows the same balance and codes for the signed-in customer.
 *  - Signed out: how to earn + Join / Sign in (the store's centered sign-in pop-up when it's available).
 *  - Signed in: balance, rewards (200 = $10 off $60+, 400 = $20 off $120+, one per order), unused codes with
 *    Copy / Use now, ways to earn, recent activity, and a link to My Account.
 */
(function () {
  var signedIn = document.documentElement.getAttribute('data-rv-signed-in') === 'true';
  var LOGIN = '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search);
  var ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
  function load() { return fetch('/apps/rv/points', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function useCode(code) { window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart'; }
  function date(t) { try { return new Date(t).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } catch (e) { return ''; } }

  function tiersHtml(tiers) {
    return '<ul class="rv-pts__tiers">' + tiers.map(function (t) {
      return '<li><strong>' + t.cost + ' points</strong><span>$' + t.value + ' off orders $' + t.min + '+</span></li>';
    }).join('') + '</ul><p class="rv-acct__fine">One reward per order.</p>';
  }

  function render(body, s) {
    var tiers = (s.tiers || []).slice().sort(function (a, b) { return a.cost - b.cost; });
    var earn = s.earn || { signup: 50, birthday: 50 };
    var orderRow = earn.perDollar ? '<li class="rv-pts__way"><span>Every order of $' + earn.orderMin + ' or more</span><em>' + earn.perDollar + ' point' + (earn.perDollar === 1 ? '' : 's') + ' per $1</em></li>' : '';
    var expiryNote = s.expiryMonths ? '<p class="rv-acct__fine">Points expire ' + s.expiryMonths + ' months after you earn them.</p>' : '';
    if (!s.signedIn) {
      body.innerHTML = '<div class="rv-ptsp">' +
        '<p class="rv-ptsp__lead">Join Radiance Veil and earn points toward money off.</p>' +
        '<ul class="rv-pts__ways"><li class="rv-pts__way"><span>Create an account</span><em>' + earn.signup + ' points</em></li>' +
        orderRow + '<li class="rv-pts__way"><span>Your birthday, every year</span><em>' + earn.birthday + ' points</em></li></ul>' + expiryNote +
        '<h3 class="rv-pts__h3">Rewards</h3>' + tiersHtml(tiers) +
        '<a class="rv-wl__btn rv-wl__btn--solid rv-ptsp__join" href="' + LOGIN + '" data-rv-points-signin>Join or sign in</a></div>';
      return;
    }
    var first = tiers[0] || { cost: 200, value: 10 };
    var html = '<div class="rv-ptsp"><div class="rv-pts__balance"><p class="rv-pts__num">' + s.points + '</p><p class="rv-pts__label">Veil Points</p></div>' +
      (s.nextExpiry && s.points ? '<p class="rv-acct__fine" style="text-align:center;margin:-8px 0 18px;">' + s.nextExpiry.pts + ' points expire ' + date(s.nextExpiry.date) + '</p>' : '');
    if ((s.codes || []).length) {
      html += '<h3 class="rv-pts__h3">Your rewards</h3><ul class="rv-pts__codes">' + s.codes.map(function (c) {
        return '<li><div><code>' + esc(c.code) + '</code><span>$' + c.value + ' off orders $' + c.min + '+</span></div>' +
          '<button type="button" class="rv-wl__link" data-copy="' + esc(c.code) + '">Copy</button><button type="button" class="rv-wl__link" data-use="' + esc(c.code) + '">Use now</button></li>';
      }).join('') + '</ul>';
    }
    html += '<h3 class="rv-pts__h3">Rewards</h3>' + tiersHtml(tiers);
    var can = tiers.filter(function (t) { return s.points >= t.cost; });
    if (can.length) {
      html += can.map(function (t) { return '<button type="button" class="rv-wl__btn rv-wl__btn--solid rv-pts__redeem" data-value="' + t.value + '">Get $' + t.value + ' off ($' + t.min + '+) for ' + t.cost + ' points</button>'; }).join('');
    } else {
      html += '<div class="rv-pts__bar" aria-hidden="true"><span style="width:' + Math.round(s.points / first.cost * 100) + '%"></span></div>' +
        '<p class="rv-acct__fine">' + (first.cost - s.points) + ' more points to your first $' + first.value + ' off.</p>';
    }
    html += '<p class="rv-acct__msg" role="status" data-msg></p>';
    html += '<h3 class="rv-pts__h3">Ways to earn</h3><ul class="rv-pts__ways">' +
      '<li class="rv-pts__way"><span>Create an account</span><em>' + earn.signup + ' points</em><b class="rv-pts__done">' + (s.signup ? 'Earned' : '') + '</b></li>' + orderRow +
      '<li class="rv-pts__way"><span>Your birthday, every year</span><em>' + earn.birthday + ' points</em>' +
      (s.birthday ? '<b class="rv-pts__done">Added</b>' : '<a class="rv-wl__link" href="/apps/rv/account?tab=profile#birthday">Add birthday</a>') + '</li></ul>' + expiryNote;
    if ((s.history || []).length) {
      html += '<h3 class="rv-pts__h3">Recent activity</h3><ul class="rv-pts__log">' + s.history.map(function (e) {
        return '<li><span>' + esc(e.why) + '</span><time>' + date(e.t) + '</time><b>' + (e.pts > 0 ? '+' : '') + e.pts + '</b></li>';
      }).join('') + '</ul>';
    }
    body.innerHTML = html + '</div>';
  }

  function open() {
    var dlg = el('<dialog class="rv-wl-drawer rv-pts-drawer" aria-label="Veil Points"><div class="rv-wl-drawer__head"><p class="rv-wl-drawer__title">Veil Points</p>' +
      '<button type="button" class="rv-wl-dialog__close" aria-label="Close">' + ICON_X + '</button></div>' +
      '<div class="rv-wl-drawer__body"><p class="rv-acct__muted">Loading…</p></div>' +
      (signedIn ? '<div class="rv-wl-drawer__foot"><a class="rv-wl__btn" href="/apps/rv/account?tab=points">Go to My Account</a></div>' : '') + '</dialog>');
    document.body.appendChild(dlg);
    var body = dlg.querySelector('.rv-wl-drawer__body');
    function close() { dlg.classList.remove('is-open'); setTimeout(function () { if (dlg.open) dlg.close(); }, 250); }
    dlg.addEventListener('close', function () { dlg.remove(); document.documentElement.classList.remove('rv-wl-drawer-open'); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) { close(); return; }
      var t = e.target.closest('button, a'); if (!t) return;
      if (t.classList.contains('rv-wl-dialog__close')) { close(); return; }
      if (t.hasAttribute('data-rv-points-signin') && typeof window.rvOpenSignIn === 'function') {
        e.preventDefault(); close(); setTimeout(function () { if (!window.rvOpenSignIn()) window.location.href = LOGIN; }, 260); return;
      }
      if (t.hasAttribute('data-copy')) {
        var code = t.getAttribute('data-copy');
        (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(function () { t.textContent = 'Copied'; setTimeout(function () { t.textContent = 'Copy'; }, 1800); }).catch(function () {});
        return;
      }
      if (t.hasAttribute('data-use')) { useCode(t.getAttribute('data-use')); return; }
      if (t.hasAttribute('data-value')) {
        var msg = body.querySelector('[data-msg]');
        body.querySelectorAll('.rv-pts__redeem').forEach(function (b) { b.disabled = true; });
        msg.textContent = 'Creating your code…';
        fetch('/apps/rv/points/redeem', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ value: Number(t.getAttribute('data-value')) }) })
          .then(function (r) { return r.json(); })
          .then(function (r) {
            if (!r.ok) throw r;
            return load().then(function (s) { render(body, s); var m = body.querySelector('[data-msg]'); if (m) m.textContent = 'Your code ' + r.code + ' is ready. Tap Use now to add it to your cart.'; });
          })
          .catch(function (r) {
            body.querySelectorAll('.rv-pts__redeem').forEach(function (b) { b.disabled = false; });
            msg.textContent = r && r.reason === 'slow_down' ? 'One moment, then try again.' : 'Something went wrong. Your points are safe. Please try again.';
          });
      }
    });
    dlg.showModal();
    document.documentElement.classList.add('rv-wl-drawer-open');
    requestAnimationFrame(function () { dlg.classList.add('is-open'); });
    load().then(function (s) { render(body, s); }).catch(function () { body.innerHTML = '<p class="rv-acct__muted">Veil Points couldn’t load. Please try again.</p>'; });
  }

  // Capture phase, before the theme's own link handlers.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-rv-points]');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    var menu = link.closest('.drawer-menu');
    if (menu && menu.classList.contains('active')) {
      var overlay = menu.querySelector('[data-overlay]'); if (overlay) overlay.click();
      setTimeout(open, 400);
    } else open();
  }, true);
  window.rvOpenPoints = open;
})();
